// import api from './api';

// export const reportService = {
//   async getDashboardData() {
//     const response = await api.get('/reports/dashboard');
//     return response.data;
//   },

//   async getMemberSummary(params = {}) {
//     const response = await api.get('/reports/member-summary', { params });
//     return response.data;
//   },

//   async getLoanPortfolio(params = {}) {
//     const response = await api.get('/reports/loan-portfolio', { params });
//     return response.data;
//   },

//   async getSavingsSummary(params = {}) {
//     const response = await api.get('/reports/savings-summary', { params });
//     return response.data;
//   },

//   async getCollectionSummary(params = {}) {
//     const response = await api.get('/reports/collection-summary', { params });
//     return response.data;
//   },

//   async exportMemberList(params = {}) {
//     const response = await api.get('/reports/excel/member-list', {
//       params,
//       responseType: 'blob',
//     });
//     return response.data;
//   },
// };


import api from './api';

export const reportService = {
  async getDashboardData() {
    const response = await api.get('/reports/dashboard');
    return response.data;
  },

  async getMemberSummary(params = {}) {
    const response = await api.get('/reports/member-summary', { params });
    return response.data;
  },

  async getLoanPerformance(params = {}) {
    const response = await api.get('/reports/loan-performance', { params });
    return response.data;
  },

  async getCollectionReport(params = {}) {
    const response = await api.get('/reports/collection-report', { params });
    return response.data;
  },

  async getSavingsSummary(params = {}) {
    const response = await api.get('/reports/savings-summary', { params });
    return response.data;
  },

async exportMemberList(params = {}) {
  const response = await api.get('/reports/export/members', {
    params,
    responseType: 'blob'
  });
  return response.data;
},

async exportLoanReport(params = {}) {
  const response = await api.get('/reports/export/loans', {
    params,
    responseType: 'blob'
  });
  return response.data;
},

async exportSavingsReport(params = {}) {
  const response = await api.get('/reports/export/savings', {
    params,
    responseType: 'blob'
  });
  return response.data;
},

async exportCollectionsReport(params = {}) {
  const response = await api.get('/reports/export/collections', {
    params,
    responseType: 'blob'
  });
  return response.data;
}
};